import Grid from "@mui/material/Grid2";
import ExtractionTableOptions from "./ExtractionTableRadioOptions";
import TravlLandUseDropdown from "./TravlLandUseDropDown";
import { DataExtractionRowViewModel } from "./ViewModels/DataExtractionTableRow";
import { useState } from "react";
import DirectionChoiceDialog from "./DirectionChoiceDialog";
import ExportToCsvDialog from "./ExportToCsvConfimationDialog";
import ExtractAllOptionsDialog from "./ExtractAllOptionsDialog";
import { useNavigate } from "react-router-dom";
import { useTravlData } from "./TravlContext";
import Button from "@mui/material/Button";

interface IProps {
    landUse: string;
    setLandUse: (value: string) => void;
    rows: DataExtractionRowViewModel[];
    rowKeys: (keyof DataExtractionRowViewModel)[];
    action: string;
    setAction: React.Dispatch<React.SetStateAction<string>>;
    selectedRowCode: string;
}

export default function TableOptions({ landUse, setLandUse, rows, rowKeys, action, setAction, selectedRowCode }: IProps) {
    const [extractMode, setExtractMode] = useState("counts");
    const [exportMode, setExportMode] = useState("site/survey");
    const [openDirectionChoiceDialog, setOpenDirectionChoiceDialog] = useState(false);
    const [openExportCsvDialog, setOpenExportCsvDialog] = useState(false);
    const [openExtractDialog, setOpenExtractDialog] = useState(false);

    const { exportToCsv } = useTravlData();

    const navigate = useNavigate();

    const continueAction = () => {

        if (action === "all") {
            setOpenExtractDialog(true);
            return;
        }
        // if action == "highlighted" then navigate to extraction page and show only the 1 highlighted survey
        // if extractMode == "counts" then navigate to extraction page and show only the counts for the highlighted survey
        // if extractMode == "purpose" then navigate to extraction page and show only the purpose data for the highlighted survey
        // if extractMode == "origins" then navigate to extraction page and show only the Origins data for the highlighted survey


        if (action === 'highlighted') {
            switch (extractMode) {
                case "counts":
                    navigate(`/travl/extract?mode=counts&survey=${selectedRowCode}`);
                    break;
                case "purpose":
                    navigate(`/travl/extract?mode=purpose&survey=${selectedRowCode}`);
                    break;
                case "origins":
                    navigate(`/travl/extract?mode=origins&survey=${selectedRowCode}`);
            }
            return;
        }


        // if action == "selected" then output csv
        if (exportMode == "site/survey") {
            setOpenExportCsvDialog(true);
        }
        // if exportMode == "counts" then output csv with only survey data

        if (exportMode === 'counts') {
            setOpenDirectionChoiceDialog(true);
            return;
        }


    }

    const exportData = () => {
        if (!rows || rows.length === 0) return;

        const dataToExport = rows.map(row => {
            const obj: Record<string, unknown> = {};
            rowKeys.forEach(key => {
                obj[key as string] = row[key] ?? "";
            });
            return obj;
        });

        exportToCsv(dataToExport);
    };

    return (
        <Grid container size={12}>
            <TravlLandUseDropdown selectedValue={landUse} setSelectedValue={setLandUse} continueAction={continueAction} disableButton={action === 'all' && landUse === 'All Surveys'} />
            <ExtractionTableOptions action={action} setAction={setAction} extractMode={extractMode} setExtractMode={setExtractMode} exportMode={exportMode} setExportMode={setExportMode} />
            <Grid size={2}>
                <Button onClick={exportData}>Export All</Button>
            </Grid>

            <DirectionChoiceDialog open={openDirectionChoiceDialog} onClose={() => setOpenDirectionChoiceDialog(false)} landUse={landUse} />



            <ExportToCsvDialog open={openExportCsvDialog} onClose={() => setOpenExportCsvDialog(false)} landUse={landUse} />
            <ExtractAllOptionsDialog open={openExtractDialog} onClose={() => setOpenExtractDialog(false)} landUse={landUse} />
        </Grid>
    )
}